import { post } from "api/helper";
import { ProcessedApiResponse } from "api/interfaces";
import { NewsletterFormValues } from "domain/public/LandingPage/Newsletter/Form/interfaces";
import { RECEIVE_NEWSLETTERS_ACIN_CAMPAIGNS } from "./configs";

export const subscribeNewsletter = async (
  values: NewsletterFormValues,
  token: string
): Promise<ProcessedApiResponse> => {
  return post("v1/newsletters", {
    recaptchaToken: token,
    email: values.email,
    subscriptionIds: [RECEIVE_NEWSLETTERS_ACIN_CAMPAIGNS],
  });
};
